export const scoreMap = {
  "Q1": { "A": 2, "B": 1, "C": 3, "D": 4 },
  "Q2": { "A": 2, "B": 1, "C": 3, "D": 4 },
  "Q3": { "A": 2, "B": 3, "C": 4, "D": 1 },
  "Q4": { "A": 1, "B": 2, "C": 4, "D": 3 },
  "Q5": { "A": 2, "B": 3, "C": 4, "D": 1 },
  "Q6": { "A": 4, "B": 3, "C": 1, "D": 2 },
  "Q7": { "A": 4, "B": 2, "C": 3, "D": 1 },
  "Q8": { "A": 3, "B": 4, "C": 2, "D": 1 },
  "Q9": { "A": 3, "B": 2, "C": 1, "D": 4 },
  "Q10": { "A": 4, "B": 3, "C": 1, "D": 2 },
  "Q11": { "A": 3, "B": 4, "C": 2, "D": 1 }
};
export function calculateScore(answers: Record<string, string>) {
  const scores = Object.entries(answers).map(([qid, answer]) => {
    const questionScore = (scoreMap as Record<string, Record<string, number>>)[qid]?.[answer] ?? 0;
    return questionScore;
  });

  const total = scores.reduce((sum, s) => sum + s, 0);
  const avg = scores.length > 0 ? total / scores.length : 0;

 let level: "junior" | "medior" | "senior";
if (total <= 24) level = "junior";
else if (total <= 34) level = "medior";
else level = "senior";

  return { total, avg, level };
}


